<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import InboxesAPI from 'dashboard/api/inboxes';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const confirmDialog = ref(null);
const isSubmitting = ref(false);

const openConfirmation = () => confirmDialog.value?.open();

const enqueueBackfill = async () => {
  isSubmitting.value = true;
  try {
    await InboxesAPI.backfillProtocols(props.inbox.id);
    confirmDialog.value?.close();
    useAlert(t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.QUEUED'));
  } catch (error) {
    useAlert(t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <SettingsToggleSection
    class="mb-4"
    :header="t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.TITLE')"
    :description="t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.DESCRIPTION')"
    hide-toggle
  >
    <template #editor>
      <div class="flex justify-end">
        <Button
          icon="i-lucide-ticket"
          :label="t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.ACTION')"
          @click="openConfirmation"
        />
      </div>
    </template>
  </SettingsToggleSection>

  <Dialog
    ref="confirmDialog"
    type="alert"
    :title="t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.CONFIRM_TITLE')"
    :description="
      t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.CONFIRM_DESCRIPTION')
    "
    :confirm-button-label="
      t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.CONFIRM')
    "
    :cancel-button-label="t('INBOX_MGMT.SETTINGS_POPUP.TICKET_BACKFILL.CANCEL')"
    confirm-button-icon="i-lucide-ticket"
    cancel-button-icon="i-lucide-x"
    :is-loading="isSubmitting"
    @confirm="enqueueBackfill"
  />
</template>
